module.exports = __webpack_public_path__ + "media/img/sbt-test/Scholarships2u-Maths-Test-fb1c03521c7ae135bf21003f7ba0c263.svg";